import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { allFilterBys, criteriaArgumentsMap } from './filter-options';
import { createSupplierCriteriaArguments, createWarehouseCriteriaArguments } from './filter-options/static-criteria-arguments';
import { usePurchaseOrdersGridContext } from './purchase-orders-grid-context';
import FilterBar from '../../../components/filter-bar';
import { criteriaOperatorsMap } from '../../../containers/base-filter-bar-container/criteria-operators';
import style from '../../../containers/orders-filter-bar-container/style.module.less';
import Global from '../../../store/global-selectors';

export const PurchaseOrderFilterBar = () => {
  const intl = useIntl();
  const { appliedFilters, onFiltersChanged, clearFilters, suppliers } = usePurchaseOrdersGridContext();
  const warehouses = useSelector(Global.selectSellerInventoryWarehouses);

  const dynamicCriteriaArgumentsMap = useMemo(() => {
    return {
      ...criteriaArgumentsMap,
      supplier: createSupplierCriteriaArguments(suppliers),
      warehouse: createWarehouseCriteriaArguments(warehouses, intl),
    };
  }, [suppliers, warehouses, intl]);

  return (
    <div className={style['filter-bar-wrapper']}>
      <FilterBar
        allFilterBys={allFilterBys}
        appliedFilters={appliedFilters}
        clearFilters={clearFilters}
        criteriaArgumentsMap={dynamicCriteriaArgumentsMap}
        criteriaOperatorsMap={criteriaOperatorsMap}
        onFiltersChanged={onFiltersChanged}
        popularFilterBys={allFilterBys}
        showOtherFilter={false}
      />
    </div>
  );
};
